module.exports = __webpack_public_path__ + "assets/images/unavailability-discovery-ff7d81.svg";